module.exports = __webpack_public_path__ + "static/media/entrance.5d7d2665.svg";